import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINT } from '../../../_constants/endpoints';
import { LayoutConfigService } from '../../layout';

const API_CUSTOMER_EVENT = API_ENDPOINT + 'c-io/track-event';


@Injectable({providedIn: 'root'})
export class CustomerIoService {

  constructor(private layoutConfigService: LayoutConfigService, private http: HttpClient) {
  }

  trackEvent(event_name: string): Observable<any> {
    // const config = this.layoutConfigService.getConfig();
    // if (!country_code) {
    //   country_code = this.layoutConfigService.getConfig('site.countryCode');
    // }

    return this.http.post<any>(API_CUSTOMER_EVENT + '/', {event: event_name});
  }

}
